import MuiDivider, { DividerProps } from '@mui/material/Divider';

export type { DividerProps };

export const Divider = (props: DividerProps) => <MuiDivider {...props} />;
